var TILE_SIZE = 256;
var TILE_URL_LABEL     = 'https://mt1.google.com/vt/lyrs=h';
var TILE_URL_SATELLITE = 'https://mt1.google.com/vt/lyrs=s';
var TILE_URL_VECTOR    = 'https://mt1.google.com/vt/lyrs=m';

// DEBUG
//var HOST_URL = 'http://dv2.ev-cuhk.net/';
// RELEASE
var HOST_URL = 'https://ev-cuhk.net/';
// API path (change later in real deployment)
HOST_URL += 'api_v2/';


var ZOOM_MIN = 15;
var ZOOM_MAX = 17;

var tileDataList = [];
var sqLiteDataCount = 0;
var currentDataCount = 0;
var uploadCompleteCallback = null;



function Point(x, y) {
  return {x: x, y: y};
}

// Convert the lat lng to world point
function latLngToWorldPoint(latLng) {
  var x = (latLng.lng + 180) / 360 * 256;
  var y = ((1 - Math.log(Math.tan(latLng.lat * Math.PI / 180) + 1 / Math.cos(latLng.lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, 0)) * 256;
  return Point(x, y);
}

export function findAllTileDataList(ulLatLng, brLatLng, callback) {
  console.log("findAllTileDataList");

  var ulWorldPoint = latLngToWorldPoint(ulLatLng);
  var brWorldPoint = latLngToWorldPoint(brLatLng);

  tileDataList = [];
  var tileUrlArr = [{url: TILE_URL_LABEL, kind: "lb"}, {url: TILE_URL_SATELLITE, kind: "st"}, {url: TILE_URL_VECTOR, kind: "vt"}];

  // Three zoom levels
  for (var z = ZOOM_MIN; z <= ZOOM_MAX; z++) {
    // var ulWorldPoint = canvasPointToWorldPoint(ulPoint, z);
    // var brWorldPoint = canvasPointToWorldPoint(brPoint, z);

    // Equal to Math.pow(2, z)
    var scale = 1 << z;

    // Tile Coordinates
    // In Google, y increases as the map shifts down
    var top = Math.floor(ulWorldPoint.y * scale / TILE_SIZE);
    var bottom = Math.ceil(brWorldPoint.y * scale / TILE_SIZE);
    var left = Math.floor(ulWorldPoint.x * scale / TILE_SIZE);
    var right = Math.ceil(brWorldPoint.x * scale / TILE_SIZE);

    console.log("ZOOM LEVEL: " + z);
    console.log("============");
    console.log("TOP:        " + top);
    console.log("BOTTOM:     " + bottom);
    console.log("LEFT:       " + left);
    console.log("RIGHT:      " + right);

    // Tile Coordinates
    var xydata = [];
    for (var i = left; i <= right; i++) {
      for (var j = top; j <= bottom; j++) {
        xydata.push([ i, j ]);
      }
    }

    // Push tile relevant data, like url, kind, x, y, z to tileDataList
    for (var i = 0; i < tileUrlArr.length; i++) {
      for (var j = 0; j < xydata.length; j++) {
        var tileData = {};
        tileData.url = tileUrlArr[i].url + "&x=" + xydata[j][0] + "&y=" + xydata[j][1] + "&z=" + z;

        tileData.kind = tileUrlArr[i].kind;
        tileData.x = xydata[j][0];
        tileData.y = xydata[j][1];
        tileData.z = z;
        tileData.ulLat = ulLatLng.lat;
        tileData.brLat = brLatLng.lat;
        tileData.ulLng = ulLatLng.lng;
        tileData.brLng = brLatLng.lng;

        tileDataList.push(tileData);
      }
    }
  }

  if (callback != null) {
    callback(tileDataList.length);
  }
}

export function downloadAllTileDataList(donwloadCompleteCallback) {
  console.log("downloadAllTileDataList");

  var tileDataCount = 0;

  // For each tile data, convert its image to blob
  let i = 0;
  function downloadLoop() {
    setTimeout(function() {
      let tileData = tileDataList[i];
      imgToBase64ViaFileReader(tileData.url, function(dataURL) {
        tileData.base64_string = encodeURIComponent(dataURL);
        tileData.blob_data = dataURLtoBlob(dataURL);

        if (++i < tileDataList.length) {
          downloadLoop();
        }
        else {
          console.log("TileDataList");
          console.log("============");
          console.log(tileDataList);
        }
        donwloadCompleteCallback(i)
      });
    }, 20)
  }
  downloadLoop();
}

export function uploadAllTileDataList(epack_id, completeCallback) {
  console.log("uploadAllTileDataList");

  tileDataList.forEach(function(tileData) {
    tileData.epack_id = epack_id;
  });

  uploadCompleteCallback = completeCallback;

  saveToSQLite(epack_id);
}

function imgToBase64ViaFileReader(imgUrl, callback) {
  var xhr = new XMLHttpRequest();

  // xhr.onLoad means finisheed loading
  xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
      // callback function with param = reader.result
      callback(reader.result);
    }
    reader.readAsDataURL(xhr.response);
  };

  // xhr's actions
  xhr.open('GET', imgUrl);
  xhr.responseType = 'blob';
  xhr.send();
}

function dataURLtoBlob(dataURL, callback) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURL.split(',')[1]);

  // separate out the mime component
  // var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  // var bb = new BlobBuilder();
  // bb.append(ab);
  // return bb.getBlob(mimeString);

  return ia;
}

function uploadTileData(tileData) {
  APIRequest(HOST_URL + "upload_tile.php", tileData, uploadTileDataOK, uploadTileDataFailed);
}

function uploadTileDataOK(res) {
  console.log("uploadTileDataOK");
  console.log(res);
}

function uploadTileDataFailed(XMLHttpRequest, textStatus, err) {
  console.log("uploadTileDataFailed");
  console.log(err);
}

// Make use of sql.js
function saveToSQLite(epack_id) {
  console.log("saveToSQLite");

  var db_lb = new window.SQL.Database();
  var db_st = new window.SQL.Database();
  var db_vt = new window.SQL.Database();

  var db_arr = {"lb": db_lb, "st": db_st, "vt": db_vt};

  var tileDataCount = 0;

  tileDataList.forEach(function(tileData) {
    tileDataCount = tileDataCount + 1;

    var db = db_arr[tileData.kind];
    runSQLite(db, tileData.epack_id, tileData.kind, tileData.x, tileData.y, tileData.z, tileData.blob_data, tileData.ulLat, tileData.brLat, tileData.ulLng, tileData.brLng);
  });

  sqLiteDataCount = Object.keys(db_arr).length;
  currentDataCount = sqLiteDataCount;
  for (var key in db_arr) {
    var db_binary_array = db_arr[key].export();
    var blob = new Blob([db_binary_array]);
    var formData = new FormData();
    formData.append("epack_id", epack_id);
    formData.append("kind", key);
    formData.append("sqlite_file", blob);
    uploadSQLiteData(formData);

  }
}

function runSQLite(db, epack_id, kind, x, y, z, blob_data, top, bottom, left, right) {
  var sqlstr = "SELECT name FROM sqlite_master WHERE type='table' AND name='tiles';";
  var res = db.exec(sqlstr);

  if (res.length > 0) {

  }
  else {
    db.run("CREATE TABLE IF NOT EXISTS metadata (name text, value text)");
    db.run("CREATE TABLE IF NOT EXISTS tiles (zoom_level integer, tile_column integer, tile_row integer, tile_data BLOB)");

    // Tmp
    db.run("CREATE UNIQUE INDEX tile_index ON tiles (zoom_level, tile_column, tile_row)");
    db.run("CREATE UNIQUE INDEX name_index ON metadata (name)");

    // Later
    db.run("INSERT INTO metadata (name, value) VALUES ('bounds', '" + left + "," + bottom + "," + right + "," + top + "')");
    // zoom levels
    db.run("INSERT INTO metadata (name, value) VALUES ('minzoom', '15')");
    db.run("INSERT INTO metadata (name, value) VALUES ('maxzoom', '17')");
    // db.run("INSERT INTO metadata (name, value) VALUES ('maxzoom', '18')");

    var db_epack_name = "epack_" + epack_id;

    db.run("INSERT INTO metadata (name, value) VALUES ('name', " + "'" + db_epack_name + "')");
    db.run("INSERT INTO metadata (name, value) VALUES ('description', " + "'" + db_epack_name + "')");
    db.run("INSERT INTO metadata (name, value) VALUES ('template', '')");

    db.run("INSERT INTO metadata (name, value) VALUES ('version', '1.0.0')");

    // IMPORTANT ****************
    // a dummy zoom level 18-21 record should be present, to prevent iOS crashing
    db.run("INSERT INTO tiles (zoom_level, tile_column, tile_row) VALUES (18, 1, 1)");
    db.run("INSERT INTO tiles (zoom_level, tile_column, tile_row) VALUES (19, 1, 1)");
    db.run("INSERT INTO tiles (zoom_level, tile_column, tile_row) VALUES (20, 1, 1)");
    db.run("INSERT INTO tiles (zoom_level, tile_column, tile_row) VALUES (21, 1, 1)");
    db.run("INSERT INTO tiles (zoom_level, tile_column, tile_row) VALUES (22, 1, 1)");
  }

  var y_tms = Math.pow(2, z) - 1 - y;

  db.run("INSERT INTO tiles (zoom_level, tile_column, tile_row) VALUES (" + z + ", " + x + ", " + y_tms + ")");

  var stmt = db.prepare("UPDATE tiles SET tile_data=$tile_data WHERE zoom_level=$zoom_level AND tile_column=$tile_column AND tile_row=$tile_row"); // SQL statement
  var stmtRes = stmt.getAsObject({$tile_data: blob_data, $zoom_level: z, $tile_column: x, $tile_row: y_tms});

  stmt.free();
}

function uploadSQLiteData(formData) {
  var request = new XMLHttpRequest();
  request.onload = function() {
    try {
      let response = JSON.parse(this.responseText);
      if (response.error != null && response.error == 0) {
        uploadSQLiteDataOK(response);
      }
      else if (response.errorMessage != null) {
        uploadSQLiteDataFailed(response.errorMessage);
      }
    } catch (e) {
    }
  };


  request.open("POST", HOST_URL + "upload_sqlite.php");

  request.send(formData);
}

function uploadSQLiteDataOK(res) {
  currentDataCount--;
  let progress = currentDataCount / sqLiteDataCount;
  if (uploadCompleteCallback != null) {
    uploadCompleteCallback(progress);
  }
  console.log("uploadSQLiteDataOK");
  console.log(res);
}

function uploadSQLiteDataFailed(err) {
  console.log("uploadSQLiteDataFailed");
  console.log(err);
}

function saveByteArray() {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";

  return function(data, name) {
    var blob = new Blob([data], {type: "octet/stream"});
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = name;
    a.click();
    window.URL.revokeObjectURL(url);
  };
}

function APIRequest(url, data, callbackOK, callbackFailed) {
  /*
  $.ajax({
    url: url,
    type: "POST",
    dataType: "text", // The respones data type
    data: data,
    success: callbackOK,
    error: callbackFailed
  });
  */
}

export default function MapTile() {

};
